import { useState, useEffect } from 'react';
import { ErrorIcons } from './_ErrorIcons';
import { configService } from '@umanforge/common';

interface EventProps {
  url: string | undefined;
  alt?: string;
  size?: number;
}


const ImageWithError = ( { url, alt, size = 8 } : EventProps ) => {

  const [ status, setStatus ] = useState<'idle' | 'loading' | 'success' | 'error'>( 'idle' );
  const [ backendUrl, setBackendUrl ] = useState<string>( '' );
  const [ blobUrl, setBlobUrl ] = useState<string | null>( null );

  useEffect( () => {
    configService.getBackendUrl().then( setBackendUrl );
  }, [] );

  useEffect( () => {
    let isMounted = true;
    setStatus( 'loading' );
    setBlobUrl( null );
    let imageUrl = url;
    if ( imageUrl && backendUrl && !/^https?:\/\//.test( imageUrl ) ) {
      imageUrl = `${backendUrl}/${imageUrl.replace( /^\/+/, '' )}`;
    }
    if ( imageUrl ) {
      fetch( imageUrl, { credentials: 'include' } )
        .then( res => {
          //if ( !res.ok ) {throw new Error( `error while fetching image ${ imageUrl }` );}
          return res.blob();
        } )
        .then( blob => {
          if ( !isMounted ) {return;}
          setBlobUrl( URL.createObjectURL( blob ) );
          setStatus( 'success' );
        } )
        .catch( () => { if ( isMounted ) {setStatus( 'error' );} } );
    } else {
      setStatus( 'error' );
    }
    return () => {
      isMounted = false;
      if ( blobUrl ) { URL.revokeObjectURL( blobUrl ); }
    };

  }, [ url, backendUrl ] );

  return (
    <div className='flex mt-1'>
      { status === 'success' && blobUrl ? (
        <div style={{
          height: `${ ( size / 4 ) }rem`,
          width: `${ ( size / 4 ) }rem`,
        }}>
          <img
            src={blobUrl}
            alt={alt}
            className='w-full aspect-square'
            onError={ () => {return setStatus( 'error' );} }
          />
        </div>
      ) : status === 'loading' ? (
        <div style={{ height: `${ ( size / 4 ) }rem`, width: `${ ( size / 4 ) }rem` }} className="flex items-center justify-center">
          <span className="animate-spin rounded-full border-2 border-gray-300 border-t-blue-500 w-6 h-6 block" />
        </div>
      ) : (
        <ErrorIcons error='no_image' size={size} />
      )}
    </div>
  );
};

export default ImageWithError;